import React from "react";
import { useSelector } from "react-redux";
import BlankTicket from "../shopping-tickets/BlankTicket";
import ShoppingTicket from "../shopping-tickets/ShoppingTicket";
import './ShoppingTicketsColumn.css'
export default function ShoppingTicketsColumn(props) {
    const activityEditMode = useSelector(store => store.reducer.activityEditMode);
    return <div id="main-content" className="shoppingTicketsColumn container">
        <div className="row">
            {props.isLPLoading ? <div className="loader" /> :
                <>
                    {
                        props.products?.map((item, index) => <div key={'ticketmahuti.activitypage' + index} className="mahuti-card col-12 col-sm-6 col-lg-3 pt-2 px-4 px-lg-3">
                            <ShoppingTicket {...item} isEditMode={activityEditMode ? activityEditMode === item.Id : false} />
                        </div>)
                    }

                    {props.landingPageParams.Show_Marketing_Banner__c && <div className="mahuti-card col-12 col-sm-6 col-lg-3 pt-2 px-4 px-lg-3">
                        <BlankTicket landingPageParams={props.landingPageParams}/>
                    </div>}
                </>


            }

        </div>

    </div>
}